"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actionCreator = void 0;
const actionCreator = (type) => ((payload) => ({
    type,
    payload,
}));
exports.actionCreator = actionCreator;
//# sourceMappingURL=base.js.map